import { FormikTouched } from 'formik';

export const isDirtyAndTouched = (
  dirty: boolean,
  touched: FormikTouched<any>
) => dirty && !!Object.entries(touched).filter(([_, t]) => !!t).length;
